'use strict';

var React = require('react');
var cs = require('classnames');
var components_Box_Box = require('../Box/Box.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var cs__default = /*#__PURE__*/_interopDefaultLegacy(cs);

const Skeleton = ({ as = "div", className = "", 
/* Default value for children makes sure that the Skeleton is always properly filled */
children = "dummy text", ...props }) => {
    const rootClasses = cs__default['default']({
        "ss-animate-pulse ss-bg-primary1-50 ss-text-transparent ss-border-transparent": true,
        "hover:ss-border-transparent focus:ss-border-transparent": true,
        "ss-shadow-none focus:ss-shadow-none ss-ring-0 focus:ss-ring-0 ss-cursor-default": true,
    }, className);
    return (React__default['default'].createElement(components_Box_Box, Object.assign({ as: as, "aria-hidden": true, className: rootClasses }, props), children));
};

module.exports = Skeleton;
